import Chip from './chip';
import EntityHelper from '../helpers/entity';
import Machine from './machine';

const collectionOf = (items, Entity, locale) => {
  if (!Array.isArray(items)) return [];
  const hasInvalidData = items.some(
    (item) => typeof item !== 'object' || Array.isArray(item),
  );
  if (hasInvalidData) return [];

  return items.map((item) => new Entity({ ...item, locale }));
};

export default class MachineGroup {
  constructor(data) {
    EntityHelper.validateData(data);
    const {
      // eslint-disable-next-line camelcase
      id, name, machines, machine_name, machine_id,
    } = data;
    // eslint-disable-next-line camelcase
    this.id = EntityHelper.setId(machine_id || id);
    // eslint-disable-next-line camelcase
    this.name = machine_name || name;
    this.machines = collectionOf(machines, Machine, this.locale);
  }

  asChip(color) {
    let chipColor = 'color_g';
    if (color) chipColor = color;
    return new Chip({
      id: this.id, title: this.name, color: chipColor, type: MachineGroup,
    });
  }
}
